import React from "react";
import { Select } from "antd";

/**
 * Shared default-workspace selector for the provisioning modals.
 *
 * `default_id_client` is the workspace a user lands on at login. This renders
 * nothing until the admin has assigned two or more distinct workspaces, since
 * one assignment is the default outright.
 *
 * `workspaces` are the ids of the assignment rows that have one, in row order.
 * Two rows may name the same workspace, so this de-duplicates them.
 *
 * Used by the Create User + Invite Users modals so both present the same
 * control.
 */
export default function DefaultWorkspaceSelect({
  workspaces = [],
  value,
  onChange,
  hint,
}) {
  const options = [...new Set(workspaces)];
  if (options.length < 2) return null;

  return (
    <div className="flex flex-col gap-2">
      <label className="text-text-default-secondary text-sm font-bold font-['Inter']">
        Default Workspace
      </label>
      <Select
        aria-label="Default workspace"
        value={value}
        onChange={onChange}
        className="w-full"
        showSearch
        optionFilterProp="label"
        options={options.map((id) => ({ value: id, label: id }))}
      />
      {hint && (
        <span className="text-xs text-text-muted font-['Inter']">{hint}</span>
      )}
    </div>
  );
}
